import React from 'react';
import PropTypes from 'prop-types';
import styles from './marquee.css';

const Marquee = ({ bg, color, text }) => {
  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  function buildQuotes() {
    const quotes = [];
    const style = {
      backgroundColor: `${bg}`,
      color: `${color}`,
      animationDuration: `${Math.round(getRandomArbitrary(8, 10))}s`,
    };

    for (let index = 0; index < 4; index++) {
      quotes.push(
        <div style={style} className={`${styles.item} itemTarget`} key={index}>
          <span className={styles.text}>{text}</span>
        </div>,
      );
    }

    return quotes;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>{buildQuotes()}</div>
    </div>
  );
};

Marquee.propTypes = {
  bg: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Marquee;
